<template>
  <div>
    <p class="friend-engagements-label">
      {{ friendEngagements.totalCount }} friend{{ friendEngagements.totalCount != 1 ? "s" : "" }}
      {{ friendEngagements.totalCount == 1 ? "has" : "have" }}
      {{ mediumSpecificVerbForEngaged(medium).toLowerCase() }}
      this
      <button
        v-if="!friendEngagements.expanded && hasHiddenFriendEngagements"
        @click="expandFriendEngagements"
        class="float-right button-text-gray-underlined"
      >
        See More
      </button>
    </p>
    <div
      ref="collapsed-friend-engagements"
      :class="{ 'friend-engagements': true, collapsed: !friendEngagements.expanded }"
    >
      <v-tooltip
        bottom
        v-for="friendEngagement in friendEngagements.items"
        :key="friendEngagement.userId"
        open-on-click
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="d-flex-item">
            <profile-avatar
              :username="friendEngagement.user.username"
              :presetProfilePic="friendEngagement.user.profilePicture"
              :size="FRIEND_ENGAGEMENT_AVATAR_SIZE"
            ></profile-avatar>
          </div>
        </template>
        <span>{{ friendEngagement.user.username }}</span>
      </v-tooltip>
    </div>
    <button
      v-if="friendEngagements.totalCount > friendEngagements.items.length && friendEngagements.expanded"
      @click="loadMoreFriendEngagements"
      class="button-text-gray-underlined mt-2 mx-auto d-block"
    >
      load more
    </button>
  </div>
</template>

<script>
import { mediumSpecificVerbForEngaged } from "@/util/mediumHelpers";
import SessionTools from "@/mixins/sessionTools";

const FRIEND_ENGAGEMENT_AVATAR_SIZE = 38;
const FRIEND_ENGAGEMENT_MIN_GAP = 8; /* Any update here should also be made to gap css style in .collapsed-friend-engagements */

export default {
  name: "work-page-friend-engagements",

  props: {
    medium: String,
    workId: String,
  },

  mixins: [SessionTools],

  computed: {
    hasHiddenFriendEngagements() {
      return this.friendEngagements.items.length > this.maxProfileAvatarsInFriendEngagementsRow;
    },

    maxProfileAvatarsInFriendEngagementsRow() {
      // If x is the max number of elements on a row, the equation is (avatar_size)X + (gap)(x-1) <= maxWidth
      // (avatar_size)X + (gap)X - gap <= maxWidth
      // avatarSize(X) + gap(X) <= maxWidth + gap
      // (avatarSize + gap)(X) <= maxWidth + gap
      // X <= (maxWidth + gap) / (avatarSize + gap)
      return Math.floor(
        (this.friendEngagementsClientWidth + FRIEND_ENGAGEMENT_MIN_GAP) /
          (FRIEND_ENGAGEMENT_AVATAR_SIZE + FRIEND_ENGAGEMENT_MIN_GAP),
      );
    },
  },

  data: function () {
    return {
      FRIEND_ENGAGEMENT_AVATAR_SIZE,

      friendEngagements: {
        totalCount: 0,
        items: [],
        expanded: false,
      },
      friendEngagementsClientWidth: 0,
      friendEngagementsResizeObserver: new ResizeObserver((entries) => {
        if (entries[0]) {
          this.friendEngagementsClientWidth = entries[0].target.clientWidth;
        }
      }),
    };
  },

  async mounted() {
    if (this.isLoggedIn) {
      await this.loadMoreFriendEngagements();
    }

    this.$nextTick(() => {
      const friendEngagementsElement = this.$refs["collapsed-friend-engagements"];
      this.friendEngagementsClientWidth = friendEngagementsElement.clientWidth;
      this.friendEngagementsResizeObserver.observe(friendEngagementsElement);
    });
  },

  methods: {
    mediumSpecificVerbForEngaged,

    async loadMoreFriendEngagements() {
      const response = await this.$axios.get("/v1/work-engagements", {
        params: {
          workId: this.workId,
          medium: this.medium,
          friendship: "friend",
          offset: this.friendEngagements.items.length,
        },
      });
      this.friendEngagements.totalCount = response.data.totalCount;
      this.friendEngagements.items = this.friendEngagements.items.concat(response.data.items);
    },

    expandFriendEngagements() {
      this.friendEngagements.expanded = true;
    },
  },
};
</script>

<style scoped>
.friend-engagements-label {
  font-size: 16px;
  margin-bottom: 8px;
  color: var(--text-middle-lightness);
}

.friend-engagements {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(38px, 1fr));
  overflow: hidden;
  column-gap: 8px; /* Any update here should also be made to FRIEND_ENGAGEMENTS_MIN_GAP */
  row-gap: 8px;
}

.friend-engagements.collapsed {
  max-height: 38px;
}
</style>
